import { listNewProjects } from '../../../features/cases/MainPage/constants';

export type AdjacentCaseDirection = 'next' | 'prev';

export type AdjacentCase = {
    router: string;
    title: string;
    description: string;
    image: string;
};

export type AdjacentCaseResult = {
    direction: AdjacentCaseDirection;
    label: string;
    case: AdjacentCase;
};

const normalizeRouter = (router: string): string => router.replace(/\/+$/, '');

export function getAdjacentCase(currentRouter: string): AdjacentCaseResult | null {
    if (listNewProjects.length < 2) return null;

    const target = normalizeRouter(currentRouter);
    const index = listNewProjects.findIndex(item => normalizeRouter(item.router) === target);

    if (index === -1) return null;

    const isLast = index === listNewProjects.length - 1;
    const neighborIndex = isLast ? index - 1 : index + 1;
    const neighbor = listNewProjects[neighborIndex]!;
    const direction: AdjacentCaseDirection = isLast ? 'prev' : 'next';

    return {
        direction,
        label: direction === 'next' ? 'Следующий проект' : 'Предыдущий проект',
        case: {
            router: neighbor.router,
            title: neighbor.title,
            description: neighbor.description,
            image: neighbor.newImg || neighbor.oldImg || '',
        },
    };
}
